import { useEffect, useRef, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import toast from "react-hot-toast";
import {
  addCategoryApi,
  blockCategoryApi,
  changeCategoryPosition,
  getCategoryList,
  updateCategory,
} from "../../Services/ApiServices";
import { Bars, Circles } from "react-loader-spinner";
import nodata from "../../Assets/Image/admin/nodata.png";
import { IMG_URL, LIST_LANGUAGES_API } from "../../Services/Api";
import edit from "../../Assets/Image/admin/Edits.png";
import { Ban, CircleOff, CircleX, Plus, Upload, GripVertical } from "lucide-react";
import Dialog from "../../Base-Component/Dialog/Dialog";
import close from "../../Assets/Image/admin/close.png";
import noImage from "../../Assets/Image/admin/user.png";
import Cropper from "react-easy-crop";
import add from "../../Assets/Image/admin/add.png";
import axios from "axios";
import { HexColorPicker } from "react-colorful";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  arrayMove,
  SortableContext,
  rectSortingStrategy,
  useSortable,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";


const SortableCategoryItem = ({
  item,
  index,
  roleData,
  handleEdit,
  handleBlock,
  handleDetails,
  navigate,
  edit,
  IMG_URL,
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: item.id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : 1,
    zIndex: isDragging ? 50 : 'auto',
  };

  const blocked = item.isBlock === 1 || item.isBlock === true || item.isBlock === '1' || item.status === 0 || item.status === '0' || item.isActive === false || item.isActive === 0 || item.isActive === '0';

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="xl:col-span-4 lg:col-span-6 md:col-span-6 col-span-12 relative group"
    >
      <div className="relative">
        {/* Clean, internal top-left corner position_number badge */}
        <div className="absolute top-3 left-3 bg-white/95 backdrop-blur-sm border border-gray-150 text-gray-800 text-[12px] font-bold w-7 h-7 rounded-full flex items-center justify-center shadow-md z-20 select-none">
          {item.position_number || index + 1}
        </div>

        {/* Action Row */}
        <div className="flex justify-end relative -mb-[43px] me-3 z-20">
          {/* Drag Handle button */}
          {roleData?.role !== "sub_admin" && (
            <div
              className="bg-white w-[32px] h-[32px] flex items-center justify-center rounded-full mx-2 cursor-grab active:cursor-grabbing shadow-md border border-gray-100 hover:bg-gray-50 transition-colors"
              {...attributes}
              {...listeners}
              title="Drag to reorder"
            >
              <GripVertical className="w-5 h-5 text-gray-500" />
            </div>
          )}
          {roleData?.role !== "sub_admin" && (
            <div
              className="bg-white p-2 rounded-full cursor-pointer shadow-md hover:bg-gray-50 transition-colors"
              onClick={(e) => {
                e.stopPropagation();
                handleEdit(item);
              }}
            >
              <img src={edit} className="w-4 h-4" alt="Edit" />
            </div>
          )}
          <div
            className="bg-white w-[32px] h-[32px] flex items-center justify-center rounded-full mx-2 cursor-pointer shadow-md hover:bg-gray-50 transition-colors"
            onClick={(e) => {
              e.stopPropagation();
              navigate("/contact-info", {
                state: { Data: item },
              });
            }}
          >
            <Plus className="w-6 h-6" />
          </div>
          {roleData?.role !== "sub_admin" && (
            <div
              className="bg-[#EF5F5F] w-[32px] h-[32px] flex items-center justify-center rounded-full cursor-pointer shadow-md hover:bg-red-600 transition-colors"
              onClick={(e) => {
                e.stopPropagation();
                handleBlock(item);
              }}
            >
              {blocked ? (
                <CircleOff className="w-5 h-5 text-white" />
              ) : (
                <Ban className="w-5 h-5 text-white" />
              )}
            </div>
          )}
        </div>

        {/* Main Card Content */}
        <div
          onClick={() => handleDetails(item)}
          className="lg:h-[300px] h-[250px] w-full rounded-2xl cursor-pointer"
          style={{
            backgroundImage: `url("${IMG_URL + item?.category_image}")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div className="bg-[#00000050] flex justify-center items-center w-full lg:h-[300px] h-[250px] rounded-2xl hover:bg-[#00000035] transition-all">
            <img
              src={item.category_logo ? IMG_URL + item.category_logo : ""}
              className="lg:w-[200px] w-[140px] lg:h-[200px] h-[140px] object-contain transition-transform group-hover:scale-105 duration-300"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  );
};

function Categorys() {
  const navigate = useNavigate();
  const imageRef = useRef(null);

  const [loader, setLoader] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isAddQuiz, setIsAddQuiz] = useState(false);
  const [cropModal, setCropModal] = useState(false);
  const [cropImg, setCropImg] = useState(false);
  const [cropStatus, setCropStatus] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
  const [croppedAreaPixelss, setCroppedAreaPixelss] = useState(null);
  const roleData = JSON.parse(localStorage.getItem("e-learn-data"));
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [img, setImg] = useState("");
  const [image, setImage] = useState("");
  const [images, setImages] = useState("");
  const [cateId, setCateId] = useState("");
  const [newImge, setNewImge] = useState({});
  const [formValue, setFormValue] = useState({});
  const [resourceData, setResourceData] = useState([]);
  const [listLanguages, setListLanguages] = useState([]);

  const sensors = useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8,
      },
    })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (over && active.id !== over.id) {
      const oldIndex = resourceData.findIndex((item) => item.id === active.id);
      const newIndex = resourceData.findIndex((item) => item.id === over.id);

      if (oldIndex !== -1 && newIndex !== -1) {
        const newOrder = arrayMove(resourceData, oldIndex, newIndex);
        
        // Optimistically update local positions
        const updatedList = newOrder.map((item, index) => ({
          ...item,
          position_number: index + 1,
        }));
        setResourceData(updatedList);

        const payload = {
          category_id: active.id,
          position_number: newIndex + 1,
        };

        changeCategoryPosition(payload)
          .then((res) => {
            toast.success("Position updated successfully");
            handleUserList(false);
          })
          .catch((err) => {
            toast.error(err?.response?.data?.message || "Failed to update position");
            handleUserList(false);
          });
      }
    }
  };

  const handleUserList = (showLoader = true) => {
    if (showLoader) {
      setLoader(true);
    }
    getCategoryList()
      .then((res) => {
        const data = res.data.data;
        const sortedData = [...data].sort(
          (a, b) => (a.position_number || 0) - (b.position_number || 0)
        );
        setResourceData(sortedData);
        if (showLoader) {
          setLoader(false);
        }
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err.response.data.message);
        }
        if (showLoader) {
          setLoader(false);
        }
      });
  };

  const handleLanguages = () => {
    axios
      .get(LIST_LANGUAGES_API)
      .then((res) => {
        const data = res.data.islanguage;
        setListLanguages(data);
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err?.response?.data?.message);
        }
      });
  };

  useEffect(() => {
    handleLanguages();
  }, []);

  useEffect(() => {
    handleUserList();
  }, []);

  const handleDetails = (data) => {
    navigate("/brand/category-details/" + data.id, {
      state: { Name: data.category_name },
    });
  };

  const handleFile = (e) => {
    setImage(e.target.files[0]);
    let imageData = URL.createObjectURL(e.target.files[0]);
    setImg(imageData);
  };

  const handleFiles = (e) => {
    setImages(e.target.files[0]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    if (isUpdate) {
      const formData = new FormData();
      formData.append("category_id", newImge.id);
      formData.append("category_name", formValue.category_name);
      formData.append("language_id", formValue.language_id);
      formData.append("color_code", formValue.color_code || "#55ad9d");
      if (image) {
        formData.append("category_image", image);
      }
      if (images) {
        formData.append("category_logo", images);
      }
      updateCategory(formData)
        .then((res) => {
          toast.success(res.data.message);
          setIsAddQuiz(false);
          handleUserList();
        })
        .catch((err) => {
          if (err?.response?.status == 401) {
            Cookies.remove("e_learning_token");
            navigate("/login");
          } else {
            toast.error(err.response.data.message);
          }
          setIsLoading(false);
        });
    } else {
      const formData = new FormData();
      formData.append("category_name", formValue.category_name);
      formData.append("language_id", formValue.language_id);
      formData.append("color_code", formValue.color_code || "#55ad9d");
      if (image) {
        formData.append("category_image", image);
      }
      if (images) {
        formData.append("category_logo", images);
      }

      formData.forEach((value, key) => {
        console.log(`${key}:`, value);
      });
      if (!images || !img) {
        toast.error("Please upload images.");
        setIsLoading(false);
      } else {
        addCategoryApi(formData)
          .then((res) => {
            if (res.data.status === 1) {
              toast.success(res.data.message);
              setIsAddQuiz(false);
              setFormValue({});
              setImg("");
              setImages("");
              setImage("");
              handleUserList();
            } else {
              toast.error(res.data.message);
            }
          })
          .catch((err) => {
            if (err?.response?.status == 401) {
              Cookies.remove("e_learning_token");
              navigate("/login");
            } else {
              toast.error(err.response.data.message);
            }
            setIsLoading(false);
          });
      }
    }
  };

  const handleEdit = (data) => {
    setNewImge(data);
    setFormValue(data);
    setImg("");
    setIsAddQuiz(true);
    setIsLoading(false);
    setIsUpdate(true);
  };

  const onCropComplete = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const onCropCompletes = useCallback((croppedArea, croppedAreaPixels) => {
    setCroppedAreaPixelss(croppedAreaPixels);
  }, []);

  const getCroppedImage = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImg(
        img ? img : IMG_URL + newImge.category_image,
        croppedAreaPixels
      );
    } catch (e) {
      console.error("Crop failed:", e);
    }
  }, [croppedAreaPixels, img, IMG_URL, newImge]);

  const getCroppedImages = useCallback(async () => {
    try {
      const croppedImage = await getCroppedImgs(
        images ? URL.createObjectURL(images) : IMG_URL + newImge.category_logo,
        croppedAreaPixelss
      );
    } catch (e) {
      console.error("Crop failed:", e);
    }
  }, [croppedAreaPixelss, images, IMG_URL, newImge]);

  const getCroppedImg = (imageSrc, croppedAreaPixels) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = imageSrc;
      image.setAttribute("crossOrigin", "anonymous");

      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = croppedAreaPixels.width;
        canvas.height = croppedAreaPixels.height;

        ctx.drawImage(
          image,
          croppedAreaPixels.x,
          croppedAreaPixels.y,
          croppedAreaPixels.width,
          croppedAreaPixels.height,
          0,
          0,
          croppedAreaPixels.width,
          croppedAreaPixels.height
        );

        const base64Image = canvas.toDataURL("image/jpeg");
        setImg(base64Image);

        fetch(base64Image)
          .then((res) => res.blob())
          .then((blob) => {
            const file = new File([blob], "cropped-image.jpg", {
              type: "image/jpeg",
            });
            setImage(file);
          });
      };

      image.onerror = (error) => {
        reject(error);
      };
    });
  };

  const getCroppedImgs = (imageSrc, croppedAreaPixels) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = imageSrc;
      image.setAttribute("crossOrigin", "anonymous");

      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        canvas.width = croppedAreaPixels.width;
        canvas.height = croppedAreaPixels.height;

        ctx.drawImage(
          image,
          croppedAreaPixels.x,
          croppedAreaPixels.y,
          croppedAreaPixels.width,
          croppedAreaPixels.height,
          0,
          0,
          croppedAreaPixels.width,
          croppedAreaPixels.height
        );

        const base64Image = canvas.toDataURL("image/jpeg");
        // setImg(base64Image);

        fetch(base64Image)
          .then((res) => res.blob())
          .then((blob) => {
            const file = new File([blob], "cropped-image.jpg", {
              type: "image/jpeg",
            });
            setImages(file);
          });
      };

      images.onerror = (error) => {
        reject(error);
      };
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValue({ ...formValue, [name]: value });
  };

  const handleOpen = () => {
    setIsAddQuiz(true);
    setIsUpdate(false);
    setIsLoading(false);
    setFormValue({});
    setImg("");
    setImages("");
    setImage("");
    setNewImge({});
  };

  const handleDelete = (e) => {
    e.preventDefault();
    setIsLoading(true);

    let obj = {
      category_id: cateId,
    };
    blockCategoryApi(obj)
      .then((res) => {
        toast.success(res.data.message);
        setIsDelete(false);
        handleUserList();
      })
      .catch((err) => {
        if (err?.response?.status == 401) {
          Cookies.remove("e_learning_token");
          navigate("/login");
        } else {
          toast.error(err?.response?.data?.message);
        }
        setIsLoading(false);
      });
  };

  const handleBlock = (data) => {
    setCateId(data.id);
    setFormValue(data);
    setIsDelete(true);
    setIsLoading(false);
  };

  return (
    <div className="fontNew md:m-4 m-1">
      <div className="flex sm:flex-nowrap flex-wrap justify-end mb-7">
        <div className="flex sm:flex-nowrap flex-wrap-reverse items-center justify-end sm:w-auto w-full">
          {roleData?.role !== "sub_admin" && (
            <div>
              <button
                onClick={handleOpen}
                className="bg-[#e29c29] text-white flex items-center py-2 px-3 sm:mb-0 mb-3 rounded-lg whitespace-nowrap"
              >
                <img src={add} className="w-6 mr-2" alt="" />
                Add Brand
              </button>
            </div>
          )}
        </div>
      </div>
      <div className="grid grid-cols-12 2xl:gap-10 xl:gap-5 gap-4">
        {loader ? (
          <div className="flex justify-center items-center col-span-12 h-[70vh]">
            <Bars
              height="35"
              width="35"
              color="#e29c29"
              ariaLabel="bars-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
          </div>
        ) : (
          <>
            {resourceData?.length === 0 ? (
              <div className="col-span-12 h-[50vh] justify-center flex items-center">
                <img src={nodata} className="w-28" alt="No data" />
              </div>
            ) : (
              <DndContext
                sensors={sensors}
                collisionDetection={closestCenter}
                onDragEnd={handleDragEnd}
              >
                <SortableContext
                  items={resourceData.map((item) => item.id)}
                  strategy={rectSortingStrategy}
                >
                  {resourceData.map((item, index) => (
                    <SortableCategoryItem
                      key={item.id}
                      item={item}
                      index={index}
                      roleData={roleData}
                      handleEdit={handleEdit}
                      handleBlock={handleBlock}
                      handleDetails={handleDetails}
                      navigate={navigate}
                      edit={edit}
                      IMG_URL={IMG_URL}
                    />
                  ))}
                </SortableContext>
              </DndContext>
            )}
          </>
        )}
      </div>

      <Dialog open={isAddQuiz} onClose={() => setIsAddQuiz(false)} size="md">
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            <div className="p-4 sm:w-auto w-[330px] md:h-[700px] h-[500px] overflow-auto fontNew">
              <h4 className="text-lg font-semibold mb-2">
                {isUpdate === true ? "Update" : "Add"} Brand
              </h4>
              <form onSubmit={handleSubmit}>
                <div className="grid grid-cols-12 ">
                  <div className="col-span-12 flex items-center mx-2 my-2">
                    <div className="w-full p-5 border-2 border-dashed rounded-md shadow-sm border-slate-300/60 dark:border-darkmode-400">
                      <div className="relative cursor-pointer h-52 w-full image-fit flex justify-center items-start">
                        {img || newImge ? (
                          <>
                            <img
                              className="rounded-md h-52"
                              alt="Midone - HTML Admin Template"
                              src={
                                img
                                  ? img
                                  : newImge.category_image
                                  ? IMG_URL + newImge.category_image
                                  : noImage
                              }
                            />
                            {img ? (
                              <div
                                className="w-6 h-6"
                                onClick={() => setImg("")}
                              >
                                <img
                                  src={close}
                                  className="w-6 h-6 -ms-4 -mt-2 relative"
                                  alt=""
                                />
                              </div>
                            ) : (
                              ""
                            )}
                          </>
                        ) : (
                          <p className="flex justify-center items-center h-52">
                            Image Not Found{" "}
                          </p>
                        )}
                      </div>
                      <div className="flex justify-center items-center mt-4">
                        <div className="relative flex items-center justify-center cursor-pointer">
                          <Upload className="text-blue-600" size={18} />
                          <span className="mr-1 text-blue-600 ml-2 sm:text-base text-sm">
                            Upload Category Image
                          </span>{" "}
                          <input
                            id="horizontal-form-1"
                            type="file"
                            className="absolute top-0 left-0 w-full h-full opacity-0"
                            accept="image/*"
                            onChange={(e) => {
                              handleFile(e);
                              setCropImg(false);
                            }}
                          />
                        </div>
                        {img && !cropImg ? (
                          <b
                            className="cursor-pointer underline sm:text-base text-sm"
                            onClick={(e) => {
                              setCropModal(true);
                              setCropStatus(1);
                            }}
                          >
                            Crop Image
                          </b>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-span-12 flex items-center mx-2 my-2">
                    <div className="w-full p-5 border-2 border-dashed rounded-md shadow-sm border-slate-300/60 dark:border-darkmode-400">
                      <div className="relative cursor-pointer h-52 w-full image-fit flex justify-center items-start">
                        {images || newImge ? (
                          <>
                            <img
                              className="rounded-md h-52 shadow-md"
                              alt="Midone - HTML Admin Template"
                              src={
                                images
                                  ? URL.createObjectURL(images)
                                  : newImge.category_logo
                                  ? IMG_URL + newImge.category_logo
                                  : noImage
                              }
                            />
                            {images ? (
                              <div
                                className="w-6 h-6"
                                onClick={() => setImages("")}
                              >
                                <img
                                  src={close}
                                  className="w-6 h-6 -ms-4 -mt-2 relative"
                                  alt=""
                                />
                              </div>
                            ) : (
                              ""
                            )}
                          </>
                        ) : (
                          <p className="flex justify-center items-center h-52">
                            Image Not Found{" "}
                          </p>
                        )}
                      </div>
                      <div className="flex justify-center items-center mt-4">
                        <div className="relative flex items-center justify-center cursor-pointer">
                          <Upload className="text-blue-600" size={18} />
                          <span className="mr-1 text-blue-600 ml-2 sm:text-base text-sm">
                            Upload Category Logo
                          </span>{" "}
                          <input
                            id="horizontal-form-1"
                            type="file"
                            className="absolute top-0 left-0 w-full h-full opacity-0"
                            accept="image/*"
                            onChange={(e) => {
                              handleFiles(e);
                              setCropImg(false);
                            }}
                          />
                        </div>
                        {images && !cropImg ? (
                          <b
                            className="cursor-pointer underline sm:text-base text-sm"
                            onClick={(e) => {
                              setCropModal(true);
                              setCropStatus(2);
                            }}
                          >
                            Crop Image
                          </b>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-2">
                    <h4 className="text-sm font-medium mb-3">
                      Select Language
                    </h4>
                    <select
                      name="language_id"
                      required
                      value={formValue.language_id || ""}
                      onChange={handleChange}
                      className="select-arrow-hidden w-full outline-[#e1c595] border-2 px-4 py-3 rounded-md"
                    >
                      <option label="Select Language"></option>
                      {listLanguages.map((item, index) => {
                        return (
                          <option key={index} value={item.id}>
                            {item.Language_name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-2">
                    <h4 className="text-sm font-medium mb-3">Brand Name</h4>
                    <input
                      type="text"
                      name="category_name"
                      required
                      value={formValue.category_name || ""}
                      onChange={handleChange}
                      className="border-2 px-4 py-3 rounded-md w-full outline-[#e1c595]"
                      placeholder="Enter"
                    />
                  </div>
                  <div className="col-span-12 md:mx-2 mx-0 my-2">
                    <h4 className="text-sm font-medium mb-3">Brand Color</h4>

                    <div className="mb-3">
                      <label className="block text-sm font-medium mb-2">
                        Color Code
                      </label>
                      <input
                        type="text"
                        name="color_code"
                        value={formValue.color_code || ""}
                        onChange={handleChange}
                        className="border-2 px-4 py-3 rounded-md w-full outline-[#e1c595]"
                        placeholder="Enter hex color code (e.g., #55ad9d)"
                        pattern="^#[0-9A-Fa-f]{6}$"
                        title="Please enter a valid hex color code (e.g., #55ad9d)"
                      />
                    </div>

                    <div className="mb-2 flex items-center justify-center space-x-3">
                      <div
                        className="w-8 h-8 rounded border"
                        style={{
                          backgroundColor: formValue.color_code || "#55ad9d",
                        }}
                      ></div>
                      <p className="text-sm font-mono fontNew">
                        {formValue.color_code || "#55ad9d"}
                      </p>
                    </div>
                    <HexColorPicker
                      color={formValue.color_code || "#55ad9d"}
                      style={{ height: "200px", width: "100%" }}
                      onChange={(e) => {
                        handleChange({
                          target: { name: "color_code", value: e },
                        });
                      }}
                    />
                  </div>
                </div>
                <div className="mt-6 flex justify-end">
                  <button
                    type="button"
                    onClick={() => setIsAddQuiz(false)}
                    className="bg-[#EF5F5F] py-2 px-7 text-white rounded-lg mr-5"
                  >
                    Close
                  </button>
                  <button
                    type="submit"
                    disabled={isLoading}
                    className="bg-[#00987C] text-white h-[45px] w-30 rounded-lg"
                  >
                    {isLoading ? (
                      <div className="flex justify-center">
                        <Circles
                          width={25}
                          height={25}
                          color="#fff"
                          ariaLabel="circles-loading"
                          wrapperStyle={{}}
                          visible={true}
                          wrapperClass=""
                        />
                      </div>
                    ) : (
                      <span className="text-base">
                        {isUpdate ? "Update" : "Add"}
                      </span>
                    )}
                  </button>
                </div>
              </form>
            </div>
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>

      <Dialog
        open={cropModal}
        onClose={() => setCropModal(false)}
        initialFocus={imageRef}
        size="lg"
      >
        <Dialog.Panel className=" w-full mx-auto bg-white px-5 pt-2">
          <Dialog.Title className="flex justify-between text-lg font-medium">
            <h4>Crop Image</h4>
            <CircleX
              color="gray"
              size={28}
              onClick={() => setCropModal(false)}
              className="cursor-pointer"
            />
          </Dialog.Title>
          <Dialog.Description className="mt-4">
            <div className="relative w-full h-[400px]">
              {cropStatus === 1 ? (
                <Cropper
                  image={img ? img : IMG_URL + newImge.category_image}
                  crop={crop}
                  zoom={zoom}
                  aspect={297 / 210}
                  onCropChange={setCrop}
                  onZoomChange={setZoom}
                  onCropComplete={onCropComplete}
                />
              ) : (
                <Cropper
                  image={
                    images
                      ? URL.createObjectURL(images)
                      : IMG_URL + newImge.category_logo
                  }
                  crop={crop}
                  zoom={zoom}
                  aspect={1}
                  onCropChange={setCrop}
                  onZoomChange={setZoom}
                  onCropComplete={onCropCompletes}
                />
              )}
            </div>
          </Dialog.Description>
          <Dialog.Footer className="flex justify-end mt-4">
            <button
              className="w-24 bg-[#00987C] px-4 py-2 rounded-lg text-white"
              type="button"
              onClick={() => {
                if (cropStatus === 1) {
                  getCroppedImage();
                } else {
                  getCroppedImages();
                }
                setCropModal(false);
              }}
            >
              Submit
            </button>
          </Dialog.Footer>
        </Dialog.Panel>
      </Dialog>

      <Dialog open={isDelete} onClose={() => setIsDelete(false)} size="2xl">
        <Dialog.Panel>
          <Dialog.Description className="rounded-none border-2 border-white">
            {(() => {
              const isFormValueBlocked = formValue.isBlock === 1 || formValue.isBlock === true || formValue.isBlock === '1' || formValue.status === 0 || formValue.status === '0' || formValue.isActive === false || formValue.isActive === 0 || formValue.isActive === '0';
              return (
                <div className="flex justify-center text-center my-4 sm:px-16 px-4 fontNew">
                  <div>
                    <h4 className="text-xl font-semibold text-black mt-6">
                      {isFormValueBlocked ? "Activate " : "Deactivate"} Brand?
                    </h4>
                    <p className="text-sm text-gray-500 my-3">
                      Are you sure you want to{" "}
                      {isFormValueBlocked ? "activate " : "deactivate"} this Brand?
                    </p>
                    <div className="mt-13 flex items-center mb-5">
                      <button
                        className="bg-[#F4F5FA] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2"
                        onClick={() => setIsDelete(false)}
                      >
                        Close
                      </button>
                      <button
                        disabled={isLoading}
                        className="bg-[#e29c29] h-[50px] sm:w-36 w-30 text-sm rounded-xl sm:mx-3 mx-2 text-white"
                        onClick={handleDelete}
                      >
                        {isLoading ? (
                          <div className="flex justify-center">
                            <Circles
                              width={25}
                              height={25}
                              color="#fff"
                              ariaLabel="circles-loading"
                              wrapperStyle={{}}
                              visible={true}
                              wrapperClass=""
                            />
                          </div>
                        ) : (
                          <span>
                            Yes, {isFormValueBlocked ? "Activate" : "Deactivate"}
                          </span>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              );
            })()}
          </Dialog.Description>
        </Dialog.Panel>
      </Dialog>
    </div>
  );
}

export default Categorys;
